import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './theme/root.css'
import 'react-spring-bottom-sheet/dist/style.css'
import App from './App';
import reportWebVitals from './reportWebVitals';

import { Provider } from "react-redux";
var stateManager = require('./utils/state/stateManager.js');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={stateManager.getStore()}>
      <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
